import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionType } from "../../../Pages/QuestionType/IQuestionType";

export const ListSubjectListSlice = createSlice({
  name: "ListSubjectListSlice",
  initialState: {} as IReduxState<IQuestionType[]>,
  reducers: {
    ListSubjectList: (state) => {
      state.isLoading = true;
    },
    successListSubject: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListSubject: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failureListSubject, ListSubjectList, successListSubject } =
  ListSubjectListSlice.actions;

export default ListSubjectListSlice.reducer;
